<div class="progressCls"></div>
<div *ngIf="showProgressBar || showLoading">
  <mat-progress-bar mode="indeterminate" color="warn"></mat-progress-bar>
</div>
<div *ngIf="showProgressspinner">
  <div class="lmask"></div>
</div>
<div align="center" *ngIf="showForms" class="tab">
  <mat-tab-group #matgroup>
    <!--Location Tab starts from here-->
    <mat-tab>
      <ng-template mat-tab-label>
        <span>Edit Location Info</span> &nbsp;
        <div *ngIf="locationInfoForm.invalid || nodesForm.invalid">
          <i class="fa fa-exclamation-circle iconEdit" aria-hidden="true"></i>
        </div>
      </ng-template>
      <form id="locationInfoForm" [formGroup]="locationInfoForm">
        <input (ngModelChange)="onchangeSave()" type="hidden" formControlName="locationInfoFormInput" [ngModel]="locationInfoForm.invalid ||
        transponderInfoForm.invalid ||
        batteryInfoForm.invalid ||
        batteryStringForm.invalid ||
        batteryBatteryForm.invalid ||
        lastVisitInfoForm.invalid ||
        nodesForm.invalid">
        <br>
        <div>
          <mat-form-field class="mat-form-field-infix-class">
            <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['houseNumberInput'])" placeholder="House Number" type='text' [(ngModel)]="locationInfoForm.houseNumberInput"
              (ngModelChange)="onChangeSysContact()" formControlName="houseNumberInput">
              <!-- <mat-error *ngIf="locationInfoForm.get('houseNumberInput').errors?.required">
                House Number is <strong>required</strong>
              </mat-error> -->
            </mat-form-field>

          <mat-form-field class="mat-form-field-infix-class">
            <input formControlName="street" matInput placeholder="Street" [(ngModel)]="locationInfoForm.street"
                   (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['street'])"
                   (ngModelChange)="onChangeSysContact()">
            <mat-error *ngIf="locationInfoForm.get('street').errors?.required">
              Street is <strong>required</strong>
            </mat-error>
            <span matSuffix class="macButton">
              <a href="https://www.google.com/maps/place/{{locationInfoForm.houseNumberInput}}+{{locationInfoForm.street}}+{{locationInfoForm.city}}+{{locationInfoForm.state}}+{{locationInfoForm.zip}}"
                target='_blank'>
                <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
              </a>
            </span>
          </mat-form-field>

          <mat-form-field class="mat-form-field-infix-class">
            <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['crossStreet'])" placeholder="Cross Street" [(ngModel)]="locationInfoForm.crossStreet"
              (ngModelChange)="onChangeSysContact()" formControlName="crossStreet">
          </mat-form-field>

          <mat-form-field class="mat-form-field-infix-class">
            <input formControlName="city" matInput placeholder="City" [(ngModel)]="locationInfoForm.city"
                   (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['city'])"
                   (ngModelChange)="onChangeSysContact()">
            <mat-error *ngIf="locationInfoForm.get('city').errors?.required">
              City is <strong>required</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field class="mat-form-field-infix-class">
            <mat-select formControlName="state" placeholder="State" [(ngModel)]="locationInfoForm.state"
                        (ngModelChange)="onChangeSysContact()">
              <mat-option>--</mat-option>
              <mat-option *ngFor="let state of states" [value]="state">
                {{state}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="locationInfoForm.get('state').errors?.required">
              Select State
            </mat-error>
          </mat-form-field>

          <mat-form-field class="mat-form-field-infix-class">
            <input formControlName="zip" matInput maxlength="5"  minlength="5" placeholder="Zip xxxxx"
                   [(ngModel)]="locationInfoForm.zip"
                   (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['zip'])"
                   (keypress)="numberOnly($event)" (paste)="restrictSpecialPaste($event)">
            <mat-error *ngIf="locationInfoForm.get('zip').errors?.required">
              Zip is <strong>required</strong>
            </mat-error>
          </mat-form-field>

          <p>
            <mat-checkbox (click)="validateFiberNodes()" class="pstypeIcon">
            </mat-checkbox>
            <mat-form-field class="mat-form-field-infix-class">
              <mat-select formControlName="mutliNodes" placeholder="Feed Multiple Nodes"
                          [(ngModel)]="locationInfoForm.mutliNodes" (ngModelChange)="onChangeFeedMultipleNodes($event)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let nodeFeed of nodeFeeds" value={{nodeFeed}}>
                  {{nodeFeed}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="locationInfoForm.get('mutliNodes').errors?.required">
                Select Feed Multiple Nodes
              </mat-error>
            </mat-form-field>
          </p>

          <form id="nodesForm" [formGroup]="nodesForm">
            <div formArrayName="node" *ngFor="let node of nodesForms.controls; let i = index;" style="display: inline;">
              <mat-form-field class="mat-form-field-infix-class" [formGroupName]="i">
                <input type="text"  (change)="trimLeadingAndTrailingSpaces(nodesForm.controls['node'])" placeholder="Node{{i+2}}" formControlName="node" matInput [matAutocomplete]="auto">
                <mat-autocomplete #auto="matAutocomplete">
                  <mat-option *ngIf="isLoadingdata" class="is-loading"><mat-spinner diameter="25"></mat-spinner></mat-option>
                  <mat-option *ngFor="let nodeValue of filterNodeOptions[i] | async" [value]="nodeValue.node"
                    (onSelectionChange)="updateFormId(nodeValue, i)">
                    {{nodeValue.node}} / {{nodeValue.nodeCmts}}
                  </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="nodesForms.controls[i].get('node').errors?.nodeError && !validateFN">
                  Select a <strong>Valid</strong> node or <strong>Enable</strong> the Checkbox to remove the Community
                  Restriction !!
                </mat-error>
                <mat-error *ngIf="nodesForms.controls[i].get('node').errors?.nodeError && validateFN">
                  Select a <strong>Valid</strong> node !!
                </mat-error>
                <mat-error *ngIf="nodesForms.controls[i].get('node').errors?.required">
                  Please select a node !!
                </mat-error>
              </mat-form-field>
              <!-- <div class="clr"></div> -->
            </div>
          </form>

          <mat-form-field class="mat-form-field-infix-class clr">
            <input formControlName="latitude" matInput placeholder="Current Gps Latitude xx.xxxxxx"
                   [(ngModel)]="locationInfoForm.latitude"
                   (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['latitude'])"
                   (ngModelChange)="onChangeSysLocation()">
            <mat-error *ngIf="locationInfoForm.get('latitude').errors?.required">
              Latitude is <strong>required</strong> !
            </mat-error>
            <mat-error
              *ngIf="locationInfoForm.get('latitude').errors?.validateDecimal && !locationInfoForm.get('latitude').errors?.required">
              Latitude <strong>Must</strong> Be 6-12 Characters After Decimal and Correctly Formatted !
            </mat-error>
            <mat-error
              *ngIf="locationInfoForm.get('latitude').errors?.validateRange && !locationInfoForm.get('latitude').errors?.required">
              {{locationInfoForm.get('latitude').errors?.validateRange}}
            </mat-error>
          </mat-form-field>
          <!-- For design change -->
          <div class="test"
              *ngIf="(locationInfoForm.get('latitude').errors?.validateRange && !locationInfoForm.get('latitude').errors?.required) || (locationInfoForm.get('latitude').errors?.validateDecimal && !locationInfoForm.get('latitude').errors?.required)">
          </div>
          <mat-form-field class="mat-form-field-infix-class clr">
            <input formControlName="longitude"  matInput placeholder="Current Gps Longitude -xx.xxxxxx"
                   [(ngModel)]="locationInfoForm.longitude"
                   (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['longitude'])"
                   (ngModelChange)="onChangeSysLocation()">
            <mat-error *ngIf="locationInfoForm.get('longitude').errors?.required">
              Longitude is <strong>required</strong> !
            </mat-error>
            <mat-error
              *ngIf="locationInfoForm.get('longitude').errors?.validateDecimal && !locationInfoForm.get('longitude').errors?.required">
              Longitude <strong>Must</strong> Be 6-12 Characters After Decimal and Correctly Formatted !
            </mat-error>
            <mat-error
              *ngIf="locationInfoForm.get('longitude').errors?.validateRange && !locationInfoForm.get('longitude').errors?.required">
              {{locationInfoForm.get('longitude').errors?.validateRange}}
            </mat-error>
            <span matSuffix class="macButton">
              <a href="https://www.google.com/maps/search/?api=1&query={{locationInfoForm.latitude}},{{locationInfoForm.longitude}}"
                target='_blank'>
                <!-- Show on Map -->
                <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
              </a>
            </span>
          </mat-form-field>
          <!-- For design change -->
          <div class="test"
              *ngIf="(locationInfoForm.get('longitude').errors?.validateDecimal && !locationInfoForm.get('longitude').errors?.required) || (locationInfoForm.get('longitude').errors?.validateRange && !locationInfoForm.get('longitude').errors?.required)">
          </div>
          <!-- <mat-form-field class="mat-form-field-infix-class clr">
            <mat-select placeholder="Calculated Runtime" [(ngModel)]="locationInfoForm.estimates"
              formControlName="estimates">
              <mat-option>--</mat-option>
              <mat-option *ngFor="let estimate of estimates" [value]="estimate">
                {{estimate}}
              </mat-option>
            </mat-select>
          </mat-form-field> -->
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select formControlName="powerNode" placeholder="Powers Node" [(ngModel)]="locationInfoForm.powerNode"
                        (ngModelChange)="onChangeSysLocation()">
              <mat-option>--</mat-option>
              <mat-option *ngFor="let nodePower of nodePowers" [value]="nodePower">
                {{nodePower}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="locationInfoForm.get('powerNode').errors?.required">
              Select Power Node
            </mat-error>
          </mat-form-field>

          <mat-form-field class="mat-form-field-infix-class">
            <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['spLocDetails'])" placeholder="Special Location Details" [(ngModel)]="locationInfoForm.spLocDetails"
              (ngModelChange)="onChangeSysLocation()" formControlName="spLocDetails">
          </mat-form-field>

          <mat-form-field class="mat-form-field-infix-class">
            <mat-select formControlName="areial" placeholder="Aerial/UG" [(ngModel)]="locationInfoForm.areial">
              <mat-option>--</mat-option>
              <mat-option *ngFor="let UG of UGs" [value]="UG">
                {{UG}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="locationInfoForm.get('areial').errors?.required">
              Select Aerial/UG
            </mat-error>
          </mat-form-field>

          <mat-form-field class="mat-form-field-infix-class">
            <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['pole'])" placeholder="Pole#" (ngModelChange)="onChangeSysContact()" formControlName="pole">
          </mat-form-field>

          <mat-form-field class="mat-form-field-infix-class">
            <mat-select formControlName="powerCompany" placeholder="Power Company"
                        [(ngModel)]="locationInfoForm.powerCompany">
              <mat-option>--</mat-option>
              <mat-option *ngFor="let powerCompany of powerCompanies" [value]="powerCompany" title="{{powerCompany}}">
                {{powerCompany}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="locationInfoForm.get('powerCompany').errors?.required">
              Select Power Company
            </mat-error>
            <span matSuffix class="macButton">
              <a href="{{powerCompanyFinderUrl}}" target='_blank'>
                <i class="fa fa-search" aria-hidden="true"></i>
              </a>
            </span>
          </mat-form-field>

          <mat-form-field class="mat-form-field-infix-class">
            <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['companyAccNum'])" placeholder="Power Company Account Number" formControlName="companyAccNum">
          </mat-form-field>

          <mat-form-field class="mat-form-field-infix-class">
            <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['companyContact'])" placeholder="Power Company Contact Number" formControlName="companyContact">
          </mat-form-field>

          <mat-form-field class="mat-form-field-infix-class">
            <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['companyWebsite'])" placeholder="Power Company Website" formControlName="companyWebsite">
          </mat-form-field>

          <!-- <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="NWT Team" [(ngModel)]="locationInfoForm.nwtTeam" formControlName="nwtTeam">

              <mat-option>--</mat-option>
              <mat-option *ngFor="let nwtTeam of nwtTeams" [value]="nwtTeam">
                {{nwtTeam}}
              </mat-option>
            </mat-select>
          </mat-form-field> -->
          <mat-form-field class="mat-form-field-infix-class">
            <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['nwtTeam'])" placeholder="NWT Team" formControlName="nwtTeam">
          </mat-form-field>

          <mat-form-field class="mat-form-field-infix-class">
            <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['nitroCompletionDate'])"  placeholder="Nitro Completion Date" formControlName="nitroCompletionDate">
          </mat-form-field>

          <!-- <mat-form-field class="mat-form-field-infix-class">
            <input matInput placeholder="Nitro Reason Not Completed" formControlName="nitroReasonNotCompleted">
          </mat-form-field> -->

          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="Power Company Account Type" [(ngModel)]="locationInfoForm.powerAccountType"
              formControlName="powerAccountType">
              <mat-option>--</mat-option>
              <mat-option *ngFor="let acctype of acctypes" [value]="acctype">
                {{acctype}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['meter'])"  placeholder="Meter #" formControlName="meter">
            <!-- <mat-error *ngIf="locationInfoForm.get('meter').errors?.required">
              Enter Meter Number
            </mat-error> -->
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <input matInput (change)="trimLeadingAndTrailingSpaces(locationInfoForm.controls['mapPageNumber'])" placeholder="Map Page Number ###-###" [(ngModel)]="locationInfoForm.mapPageNumber"
              (ngModelChange)="onChangeSysLocation()" formControlName="mapPageNumber">
          </mat-form-field>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="Business Partner Restriction"
              [(ngModel)]="locationInfoForm.businessPartnerRestriction" formControlName="businessPartnerRestriction"
              (ngModelChange)="onChangeSysLocation()">
              <mat-option>--</mat-option>
              <mat-option *ngFor="let businessPartnerRestriction of businessPartneRestrictions"
                [value]="businessPartnerRestriction">
                {{businessPartnerRestriction}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <mat-form-field style="width:290px;">
          <mat-label>Location Comments</mat-label>
          <textarea matInput rows="3" formControlName="locationComments"></textarea>
          <mat-error *ngIf="locationInfoForm.get('locationComments').errors?.maxlength">
            Comments can <strong>Maximum</strong> 255 Characters
          </mat-error>
          <mat-error *ngIf="locationInfoForm.get('locationComments').errors?.required">
            Enter Location Comments
          </mat-error>
        </mat-form-field>
        <br><br>
      </form>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <span>Edit Transponder Info</span> &nbsp;
        <div *ngIf="transponderInfoForm.invalid">
          <i class="fa fa-exclamation-circle iconEdit" aria-hidden="true"></i>
        </div>
      </ng-template>
      <form id="transponderInfoForm" [formGroup]="transponderInfoForm">
        <br>
        <div>
          <p>
            &nbsp;
            <span class="pstypeIcon">
              <nwt-power-supply-tooltip [powerSupplyType]="selectedPSType"></nwt-power-supply-tooltip>
            </span>
            <mat-form-field class="mat-form-field-infix-class">
              <mat-select formControlName="standByOpts" placeholder="StandBy/Non-StandBy"
                          [(ngModel)]="transponderInfoForm.standByOpts" (ngModelChange)="onChangePowerSupplyType()">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let standByOption of standByOptions" [value]="standByOption">
                  {{standByOption}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="transponderInfoForm.get('standByOpts').errors?.required">
                Select StandBy/Non-StandBy
              </mat-error>
            </mat-form-field>
            <mat-form-field class="mat-form-field-infix-class">
              <input formControlName="activeMacAddress"  matInput max="17" maxlength="17" min="0"
                     placeholder="ActiveMacAddress" [(ngModel)]="activeMacAddress" [value]="mac_address"
                     (change)="trimLeadingAndTrailingSpaces(transponderInfoForm.controls['activeMacAddress'])"
                     (keydown.space)="$event.preventDefault()" (keypress)="omit_special_char($event)"
                     (ngModelChange)="onMacChange($event)">
              <span matSuffix class="macButtonCreate" (click)="onClickGenerateMac()"><i matSuffix
                  class="fa fa-mouse-pointer"></i>
                &nbsp; Generate MAC &nbsp; | &nbsp;</span>
              <span *ngIf="pullTransponderButton" matSuffix class="macButtonCreate" (click)="onPullTransponder()"> Pull
                Transponder Data</span>
              <span *ngIf="!pullTransponderButton" matSuffix class="macButtonDisabled"> Pull Transponder Data</span>
              <mat-error *ngIf="transponderInfoForm.get('activeMacAddress').errors?.required">
                MAC Address is <strong>required</strong>
              </mat-error>
              <mat-error
                *ngIf="transponderInfoForm.get('activeMacAddress').errors?.validateMac && !transponderInfoForm.get('activeMacAddress').errors?.required">
                MAC Address Format is <strong>Invalid</strong> !
              </mat-error>
              <mat-error
                *ngIf="transponderInfoForm.get('activeMacAddress').errors?.validateMac00 && !transponderInfoForm.get('activeMacAddress').errors?.required">
                Please enter a <strong>valid</strong> MAC or <strong>Select</strong> the Generate MAC Placeholder
                button !
              </mat-error>
              <mat-error
                *ngIf="transponderInfoForm.get('activeMacAddress').errors?.validateExistingMac && !transponderInfoForm.get('activeMacAddress').errors?.required">
                MAC Already <strong>exists</strong> !
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(transponderInfoForm.controls['prevMacAddress'])" placeholder="Previous MAC Address" formControlName="prevMacAddress">
            </mat-form-field>
          </p>
          <p>
            <mat-form-field class="mat-form-field-infix-class">
              <input formControlName="ip" matInput placeholder="IP"
                     (change)="trimLeadingAndTrailingSpaces(transponderInfoForm.controls['ip'])">
              <!-- <b matSuffix class="macButtonCreate" (click)="onClickGenerateIP()"><i matSuffix
                  class="fa fa-mouse-pointer"></i>
                &nbsp; Get IP of MAC Address
              </b> -->
              <mat-error *ngIf="transponderInfoForm.get('ip').errors?.required">
                IP is <strong>required</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class" *ngIf="showPSNumberSelect">
              <mat-select formControlName="powerSupplyNum" placeholder="Power Supply Number"
                          [(ngModel)]="transponderInfoForm.powerSupplyNum" (ngModelChange)="onChangePowerSupplyNum()">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let PSNOption of PSNOptions" [value]="PSNOption">
                  {{PSNOption}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="transponderInfoForm.get('powerSupplyNum').errors?.required">
                Select Power Supply Number
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class" *ngIf="showPSNumberInput">
              <input formControlName="powerSupplyNum" matInput placeholder="Power Supply Number"
                     (change)="trimLeadingAndTrailingSpaces(transponderInfoForm.controls['powerSupplyNum'])"
                     (ngModelChange)="onChangePowerSupplyNum()">
              <mat-error *ngIf="transponderInfoForm.get('powerSupplyNum').errors?.required">
                Power Supply Number is <strong>required</strong>
              </mat-error>
              <mat-error *ngIf="transponderInfoForm.get('powerSupplyNum').errors?.validatePSNum
              && !transponderInfoForm.get('powerSupplyNum').errors?.required">
                Power Supply Number <strong>Should</strong> be 3-5 Characters
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Next Gen Node" [(ngModel)]="transponderInfoForm.nextGenNode"
                formControlName="nextGenNode" (ngModelChange)="onChangeNextgenType()">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let nextGenOption of nextGenOptions" [value]="nextGenOption">
                  {{nextGenOption}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </p>
          <div *ngIf="showsfp">
            <button class="apuButton" mat-raised-button (click)="openSupplyDialogsfp()">SFP Details</button> &nbsp;
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput
                     formControlName="sfpMac"
                     placeholder="MacAddress as Printed on the SFP"
                     [(ngModel)]="transponderInfoForm.sfpMac"
                     [disabled]="true"
                     [value]="sfpMAC">
            </mat-form-field>
          </div>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select formControlName="transponderVendor" placeholder="Transponder Vendor"
                        [(ngModel)]="transponderInfoForm.transponderVendor"
                        (selectionChange)="changePowerSupplyModel($event)">
              <mat-option>--</mat-option>
              <mat-option *ngFor="let transponderVendor of transponderVendors" [value]="transponderVendor">
                {{transponderVendor}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="transponderInfoForm.get('transponderVendor').errors?.required">
              Select Transponder Vendor
            </mat-error>
            <mat-error *ngIf="transponderInfoForm.get('transponderVendor').errors?.validateVendorType">
              Transponder Vendor <strong>Should</strong> be AM Communications
            </mat-error>
          </mat-form-field>

          <mat-form-field class="mat-form-field-infix-class">
            <mat-select formControlName="transponderModel" placeholder="Transponder Model"
                        [(ngModel)]="transponderInfoForm.transponderModel">
              <mat-option>--</mat-option>
              <mat-option *ngFor="let transponderModel of transponderModels" [value]="transponderModel">
                {{transponderModel}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="transponderInfoForm.get('transponderModel').errors?.required">
              Select Transponder Model
            </mat-error>
          </mat-form-field>

          <div *ngIf="showPowerSupplyModel">
            <mat-form-field class="mat-form-field-infix-class">
              <mat-select formControlName="powerSupplyModel" placeholder="PowerSupply Model *"
                          [(ngModel)]="transponderInfoForm.powerSupplyModel">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let powerSupplyModel of powerSupplyModels" [value]="powerSupplyModel">
                  {{powerSupplyModel}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="transponderInfoForm.get('powerSupplyModel').errors?.validatePowerSupplyModel">
                Select PowerSupply Model
              </mat-error>
              <mat-error *ngIf="transponderInfoForm.get('powerSupplyModel').errors?.required">
                Select PowerSupply Model
              </mat-error>
            </mat-form-field>
          </div>

          <div *ngIf="showPowerSupplyType9360">
            <mat-form-field class="mat-form-field-infix-class">
              <mat-select formControlName="powerSupplyType9360" placeholder="PowerSupply Type (9360 Model)"
                          [(ngModel)]="transponderInfoForm.powerSupplyType9360">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let powerSupplyType9360 of powerSupplyTypes" [value]="powerSupplyType9360">
                  {{powerSupplyType9360}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="transponderInfoForm.get('powerSupplyType9360').errors?.validatePowerSupply9360">
                Select PowerSupply Type (9360 Model)
              </mat-error>
            </mat-form-field>
          </div>

          <p>
            <mat-form-field class="mat-form-field-infix-class">
              <mat-select formControlName="acInputVoltage" placeholder="AC Input Voltage Rating"
                          [(ngModel)]="transponderInfoForm.acInputVoltage" (ngModelChange)="changePSAlertProfile()">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let inputVoltageRating of inputVoltageRatings" [value]="inputVoltageRating">
                  {{inputVoltageRating}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="transponderInfoForm.get('acInputVoltage').errors?.required">
                Select AC Input Voltage Rating
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select formControlName="acOutputVoltage" placeholder="AC Output Voltage Rating"
                          [(ngModel)]="transponderInfoForm.acOutputVoltage" (ngModelChange)="changePSAlertProfile()">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let outputVoltageRating of outputVoltageRatings" [value]="outputVoltageRating">
                  {{outputVoltageRating}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="transponderInfoForm.get('acOutputVoltage').errors?.required">
                Select AC Output Voltage Rating
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select formControlName="currentAmp" placeholder="Current Amp Rating"
                          [(ngModel)]="transponderInfoForm.currentAmp" (ngModelChange)="changePSAlertProfile()">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let ampRating of ampRatings" [value]="ampRating">
                  {{ampRating}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="transponderInfoForm.get('currentAmp').errors?.required">
                Select Current Amp Rating
              </mat-error>
            </mat-form-field>

            <!-- <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Current (Amp Output) Rating" [(ngModel)]="transponderInfoForm.currentAmpOutput"
              [(ngModel)]="transponderInfoForm.currentAmpOutput" (ngModelChange)="changePSAlertProfile()"
              formControlName="currentAmpOutput">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let ampOutputRating of ampOutputRatings" [value]="ampOutputRating">
                  {{ampOutputRating}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="transponderInfoForm.get('currentAmpOutput').errors?.required">
                Select Current (Amp Output) Rating
              </mat-error>
            </mat-form-field> -->

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput  (change)="trimLeadingAndTrailingSpaces(transponderInfoForm.controls['powerSupplyAlertProfile'])" placeholder="Power Supply Alert Profile" [value]=powerSupplyAlertProfile
                formControlName="powerSupplyAlertProfile">
            </mat-form-field>
          </p>

          <p>
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput  (change)="trimLeadingAndTrailingSpaces(transponderInfoForm.controls['serialNum'])" placeholder="Serial Number" formControlName="serialNum">
            </mat-form-field>

            <!-- <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Controlled Card Type" [(ngModel)]="transponderInfoForm.controlledCardType"
                formControlName="controlledCardType">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let cardType of cardTypes" [value]="cardType">
                  {{cardType}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="transponderInfoForm.get('controlledCardType').errors?.required">
                Select Controlled card type
              </mat-error>
            </mat-form-field> -->

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="DC Ready?" [(ngModel)]="transponderInfoForm.dcReady" formControlName="dcReady">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let DCReadyDecision of DCReadyDecisions" [value]="DCReadyDecision">
                  {{DCReadyDecision}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(transponderInfoForm.controls['priority'])" placeholder="Priority" formControlName="priority" (ngModelChange)="onChangeSysLocation()">
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(transponderInfoForm.controls['egisName'])" placeholder="EGIS Number" formControlName="egisName">
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select formControlName="externalSensor" placeholder="Ethernet Connected Device" [(ngModel)]="transponderInfoForm.externalSensor">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let externalSensorData of externalSensors" [value]="externalSensorData">
                  {{externalSensorData}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </p>
        </div>
        <mat-form-field style="width:290px;">
          <mat-label>Transponder Comments</mat-label>
          <textarea matInput rows="3" formControlName="transponderComments"></textarea>
          <mat-error *ngIf="transponderInfoForm.get('transponderComments').errors?.maxlength">
            Comments can <strong>Maximum</strong> 255 Characters
          </mat-error>
        </mat-form-field>
        <br><br>
      </form>
    </mat-tab>

    <!--Battery Info Tab starts from here-->
    <mat-tab>
      <ng-template mat-tab-label>
        <span>Edit Battery Info</span> &nbsp;
        <div *ngIf="batteryInfoForm.invalid || batteryStringForm.invalid || batteryBatteryForm.invalid">
          <i class="fa fa-exclamation-circle iconEdit" aria-hidden="true"></i>
        </div>
      </ng-template>
      <form id="batteryInfoForm" [formGroup]="batteryInfoForm">
        <br>
        <h5 style="color: coral">Battery Info</h5>
        <div>
          <!-- <p> -->
            <mat-form-field class="mat-form-field-infix-class">
              <mat-select formControlName="numberofBatteries" placeholder="Number Of Batteries"
                          [(ngModel)]="batteryInfoForm.numberofBatteries" (ngModelChange)="onChangeNumberOfBatteries()">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let batteries of numberofBatteries" [value]="batteries">
                  {{batteries}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="batteryInfoForm.get('numberofBatteries').errors?.required">
                Select Number Of Batteries
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select formControlName="batteriesReplaced" placeholder="Were The Batteries Replaced(Yes or No)?"
                          [(ngModel)]="batteryInfoForm.batteriesReplaced" (ngModelChange)="onChangeBatteriesReplaced()">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let batteries of batteriesReplaced" [value]="batteries">
                  {{batteries}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="batteryInfoForm.get('batteriesReplaced').errors?.required">
                Select Were The Batteries Replaced
              </mat-error>
            </mat-form-field>

            <!-- <mat-form-field class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(batteryInfoForm.controls['airTemperature'])" placeholder="Air Temperature" formControlName="airTemperature">
            </mat-form-field> -->
            <div class="col">
              <mat-form-field class="mat-form-field-infix-class">
                <mat-select formControlName="batteryManagerModel" placeholder="Battery Manager Model">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let batteryManagerModel of batteryManagerModels" [value]="batteryManagerModel">
                    {{batteryManagerModel}}
                  </mat-option>
                </mat-select>
                <mat-error  *ngIf="batteryInfoForm.get('batteryManagerModel').errors?.required">
                  Select Battery Manager Model
                </mat-error>
              </mat-form-field>
            </div>
          <!-- </p> -->
        </div>
      </form>

      <form id="batteryStringForm" [formGroup]="batteryStringForm">
        <div align="center" style="margin: 0 0 0 -10px;">
          <div formArrayName="batteryString" *ngFor="let node of batteryStringForms.controls; let i = index;"
            class="container">
            <!-- <small style="color: coral">String {{i+1}}</small> -->
            <div class="row" *ngIf="i==0">
              <!-- <div class="col">
                <mat-form-field class="mat-form-field-infix-class" [formGroupName]="i">
                  <mat-select placeholder="Battery Manager Model ( String {{i+1}} )" (selectionChange)="clearValidationOnChange($event)"  [(ngModel)]="node[i]"
                    formControlName="batteryManagerModel">
                    <mat-option>--</mat-option>
                    <mat-option *ngFor="let batteryManagerModel of batteryManagerModels" [value]="batteryManagerModel">
                      {{batteryManagerModel}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="batteryStringForms.controls[i].get('batteryManagerModel').errors?.required">
                    Select Battery Manager Model( String {{i+1}})
                  </mat-error>
                </mat-form-field>
              </div> -->

              <!-- <div class="col">
                <mat-form-field class="mat-form-field-infix-class" [formGroupName]="i">
                  <mat-select placeholder="Battery Separator Present" formControlName="batterySeparator">
                    <mat-option>--</mat-option>
                    <mat-option *ngFor="let batterySeparator of batterySeparatorPresent" [value]="batterySeparator">
                      {{batterySeparator}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div> -->
            </div>

            <form id="batteryBatteryForm" [formGroup]="batteryBatteryForm">
              <div formArrayName="batteryBatteries" *ngFor="let node of batteryBatteryForms.controls; let j = index;"
                style="display: inline-block;">
                <div *ngIf="IsTrue(i, j)">
                  <mat-card class="example-card" style="margin:1em;">

                    <mat-card-header>
                      <mat-card-title *ngIf="!parallelBatt">String {{i+1}} - Battery - {{getBatteryNumber(j)}}</mat-card-title>
                      <mat-card-title *ngIf="parallelBatt">String {{i+1}} - Parallel Battery - {{getBatteryNumber(j)}}</mat-card-title>
                      <!-- <button *ngIf="getBatteryNumber(j) == 1" matTooltip="Clone data to other batteries" mat-mini-fab
                        style="background-color: transparent;color: black;margin-left: 37%" class="fa fa-qrcode fa-2x"
                        aria-hidden="true" (click)="enableScanner();"></button> -->
                        <button matTooltip="QR Scan" mat-mini-fab
                        style="background-color: transparent;color: black;margin-left: 37%" class="fa fa-qrcode fa-2x"
                        aria-hidden="true" (click)="enableScanner(j);"></button>
                    </mat-card-header>
                      <!--QR Scan Code-->
                      <div class="scanner-container">
                        <!--QR Scan Code with zoom features-->
                        <zxing-scanner #scanner
                                       *ngIf="scannerEnabled[j]"
                                       id="qr-reader" 
                                       [zoom]="zoom" 
                                       (scanSuccess)="scanSuccessHandler($event,j)">
                        </zxing-scanner>
                        <div *ngIf="zoomFlag[j]" class="focus-frame"></div>
                        <div *ngIf="zoomFlag[j]" class="mt-5">
                          <i aria-hidden="true" class="fa fa-search-plus zoom-icon" (click)="zoomIn()">
                            <b class="zoom-text">ZoomIn</b>
                          </i>
                          <i aria-hidden="true" class="fa fa-search-minus zoom-icon" (click)="zoomOut()">
                            <b class="zoom-text">ZoomOut</b>
                          </i>
                        </div>
                      </div>
                    <p>
                      <mat-form-field class="mat-form-field-infix-dym" hideRequiredMarker="true" [formGroupName]="j">
                        <mat-select placeholder="Battery Manufacturer/Type {{asterisk}}" [(ngModel)]="node[j]"
                          formControlName="batteryManufacturer" ngDefaultControl>
                          <mat-option>--</mat-option>
                          <mat-option *ngFor="let batteryManufacturer of batteryManufactureres"
                            [value]="batteryManufacturer">
                            {{batteryManufacturer}}
                          </mat-option>
                        </mat-select>
                        <mat-error *ngIf="batteryBatteryForms.controls[j].get('batteryManufacturer').errors?.required">
                          Select Battery Manufacturer
                        </mat-error>
                      </mat-form-field>
                    </p>
                    <p>
                      <mat-form-field class="mat-form-field-infix-dym" hideRequiredMarker="true" [formGroupName]="j">
                        <input matInput (change)="trimLeadingAndTrailingSpaces(batteryInfoForm.controls['batterySerial'])" placeholder="Battery Serial Number {{asterisk}}"
                          formControlName="batterySerial">
                        <mat-error *ngIf="batteryBatteryForms.controls[j].get('batterySerial').errors?.required">
                          Battery Serial Number is <strong>required</strong>
                        </mat-error>
                        <mat-error
                          *ngIf="batteryBatteryForms.controls[j].get('batterySerial').errors?.validateBatteryDateCode">
                          <strong>Incorrect</strong> Date Format (MMYY)
                        </mat-error>
                      </mat-form-field>
                    </p>
                    <p>
                      <mat-form-field class="mat-form-field-infix-dym" hideRequiredMarker="true" [formGroupName]="j">
                        <input matInput (change)="trimLeadingAndTrailingSpaces(batteryInfoForm.controls['batteryCode'])"  placeholder="Battery Date Code (On Battery) {{asterisk}}"
                          formControlName="batteryCode">
                        <mat-error *ngIf="batteryBatteryForms.controls[j].get('batteryCode').errors?.required">
                          Battery Date Code is <strong>required</strong>
                        </mat-error>
                        <mat-error
                          *ngIf="batteryBatteryForms.controls[j].get('batteryCode').errors?.validateBatteryDateCode">
                          <strong>Incorrect</strong> Date Format (MMYY)
                        </mat-error>
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field class="mat-form-field-infix-dym" hideRequiredMarker="true" [formGroupName]="j">
                        <input matInput (change)="trimLeadingAndTrailingSpaces(batteryInfoForm.controls['batteryInstallDate'])"  [matDatepicker]="picker" placeholder="Battery Install Date {{asterisk}}"
                          formControlName="batteryInstallDate">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        <mat-error *ngIf="batteryBatteryForms.controls[j].get('batteryInstallDate').errors?.required">
                          Battery Install Date is <strong>required</strong>
                        </mat-error>
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field class="mat-form-field-infix-dym" hideRequiredMarker="true" [formGroupName]="j">
                        <input matInput (change)="trimLeadingAndTrailingSpaces(batteryInfoForm.controls['batteryVoltageNoLoad'])"  placeholder="Battery Voltage - No Load {{asterisk}}"
                          formControlName="batteryVoltageNoLoad">
                        <mat-error *ngIf="batteryBatteryForms.controls[j].get('batteryVoltageNoLoad').errors?.required">
                          Battery Voltage - No Load is <strong>required</strong>
                        </mat-error>
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field class="mat-form-field-infix-dym" [formGroupName]="j">
                        <input matInput (change)="trimLeadingAndTrailingSpaces(batteryInfoForm.controls['batteryVoltageUnderLoad'])"  placeholder="Battery Voltage - Under Load (After 9 Minute Self-Test)"
                          formControlName="batteryVoltageUnderLoad">
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field class="mat-form-field-infix-dym" [formGroupName]="j">
                        <input matInput (change)="trimLeadingAndTrailingSpaces(batteryInfoForm.controls['batteryConductance'])"  placeholder="Battery Conductance (mhos)" formControlName="batteryConductance">
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field class="mat-form-field-infix-dym" [formGroupName]="j">
                        <input matInput (change)="trimLeadingAndTrailingSpaces(batteryInfoForm.controls['batteryConductanceCorrected'])" placeholder="Battery Conductance - Corrected to 77deg F"
                          formControlName="batteryConductanceCorrected">
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field class="mat-form-field-infix-dym" [formGroupName]="j">
                        <input matInput  (change)="trimLeadingAndTrailingSpaces(batteryInfoForm.controls['totalVoltage'])" placeholder="Total Voltage String {{i+1}} - No load (VDC)"
                          formControlName="totalVoltage">
                      </mat-form-field>
                    </p>
                  </mat-card>
                </div>
              </div>
            </form>
          </div>
        </div>
      </form>
      <br>
      <form [formGroup]="batteryInfoForm">
        <div>
          <mat-form-field style="width:290px;">
            <mat-label>Battery Comments</mat-label>
            <textarea matInput rows="3" formControlName="batteryComments"></textarea>
            <mat-error *ngIf="batteryInfoForm.get('batteryComments').errors?.maxlength">
              Comments can <strong>Maximum</strong> 255 Characters
            </mat-error>
          </mat-form-field>
        </div>
      </form>
      <br>
    </mat-tab>

    <!--Last Visit Info tab starts from here-->
    <mat-tab label="Enter Last Visit Info">
      <ng-template mat-tab-label>
        <span>Edit Last Visit Info</span> &nbsp;
        <div *ngIf="lastVisitInfoForm.invalid">
          <i class="fa fa-exclamation-circle iconEdit" aria-hidden="true"></i>
        </div>
      </ng-template>
      <p class="text-center">
        <b>Tech</b><br>
        {{userName}}
      </p>
      <form id="lastVisitInfoForm" [formGroup]="lastVisitInfoForm">
        <div>
          <p>
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(lastVisitInfoForm.controls['inspectionDate'])"   [matDatepicker]="picker" placeholder="Inspection Date" readonly="readonly" [value]="inspectionDateValue"
                formControlName="inspectionDate">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error *ngIf="lastVisitInfoForm.get('inspectionDate').errors?.required">
                Inspection Date is required
              </mat-error>
            </mat-form-field>
            <mat-checkbox class="ins_date" (change)='onChangeIns($event)'>Today</mat-checkbox>&nbsp;
            <!--<mat-form-field class="mat-form-field-infix-class" *ngIf="this.permissionValue==false">
              <mat-select placeholder="Type Of Visit" [(ngModel)]="lastVisitInfoForm.typeOfVisit"
                formControlName="typeOfVisit" (ngModelChange)="onChangevisitType()">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let visitType of TypeofVisitBP" [value]="visitType">
                  {{visitType}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('typeOfVisit').errors?.required">
                Select Type Of Visit
              </mat-error>
            </mat-form-field>-->
            <!--<mat-form-field class="mat-form-field-infix-class" *ngIf="this.permissionValue==true">
              <mat-select placeholder="Type Of Visit" [(ngModel)]="lastVisitInfoForm.typeOfVisit"
                formControlName="typeOfVisit" (ngModelChange)="onChangevisitType()">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let visitType of TypeofVisitInhouse" [value]="visitType">
                  {{visitType}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('typeOfVisit').errors?.required">
                Select Type Of Visit
              </mat-error>
            </mat-form-field>-->
              <!-- <mat-form-field class="mat-form-field-infix-class" hideRequiredMarker="true">
                  <mat-select placeholder="Type Of Visit {{asterisk}}" [(ngModel)]="lastVisitInfoForm.typeOfVisit"
                              formControlName="typeOfVisit" (ngModelChange)="onChangevisitType()">
                      <mat-option>--</mat-option>
                      <mat-option *ngFor="let visitType of visitTypes" [value]="visitType">
                          {{visitType}}
                      </mat-option>
                  </mat-select>
                  <mat-error *ngIf="lastVisitInfoForm.get('typeOfVisit').errors?.required">
                      Select Type Of Visit
                  </mat-error>
              </mat-form-field> -->

              <mat-form-field *ngIf="!permissionValue" class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Type Of Visit {{asterisk}}" [(ngModel)]="lastVisitInfoForm.typeOfVisit"
                  formControlName="typeOfVisit" (ngModelChange)="onChangevisitType()">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let visitType of visitTypesbp" [value]="visitType">
                    {{visitType}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('typeOfVisit').errors?.required">
                  Select Type Of Visit
                </mat-error>
              </mat-form-field>
              <!--Comcast User or inhouse-->
              <mat-form-field *ngIf="permissionValue" class="mat-form-field-infix-class" hideRequiredMarker="true">
                <mat-select placeholder="Type Of Visit {{asterisk}}" [(ngModel)]="lastVisitInfoForm.typeOfVisit"
                  formControlName="typeOfVisit" (ngModelChange)="onChangevisitType()">
                  <mat-option>--</mat-option>
                  <mat-option *ngFor="let visitType of visitTypesinhouse" [value]="visitType">
                    {{visitType}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="lastVisitInfoForm.get('typeOfVisit').errors?.required">
                  Select Type Of Visit
                </mat-error>
              </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Visit Status" [(ngModel)]="lastVisitInfoForm.visitsStatus"
                (ngModelChange)="onChangevisitStatus()" formControlName="visitsStatus">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let visitStatus of visitStatusvalue" [value]="visitStatus">
                  {{visitStatus}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('visitsStatus').errors?.required">
                Select Visit Status
              </mat-error>
            </mat-form-field>

            <mat-form-field *ngIf="!permissionValue" class="mat-form-field-infix-class">
              <input matInput (change)="trimLeadingAndTrailingSpaces(lastVisitInfoForm.controls['mobileno'])"  maxlength="12" autocomplete="off" (keypress)="mobilenopattern($event)"
                formControlName="mobileno" placeholder="Phone No">
              <mat-error *ngIf="lastVisitInfoForm.get('mobileno').errors?.required">
                Phone No is <strong>required</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Follow Up Reason" [(ngModel)]="lastVisitInfoForm.followUpReasons"
                (ngModelChange)="onfollowUpReasons()" formControlName="followUpReasons">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let followUpReason of followUpReasons" [value]="followUpReason">
                  {{followUpReason}}
                </mat-option>
              </mat-select>
              <!-- <mat-error *ngIf="lastVisitInfoForm.get('followUpReasons').errors?.required">
                Select Follow Up Reason
              </mat-error> -->
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Meter Pan Condition" [(ngModel)]="lastVisitInfoForm.meterPan"
                formControlName="meterPan">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let meterPanCondition of MeterPanCondition" [value]="meterPanCondition">
                  {{meterPanCondition}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('meterPan').errors?.required">
                Select Meter Pan Condition
              </mat-error>
            </mat-form-field>
<!--
            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="XOC Verified Transponder Operational" [(ngModel)]="lastVisitInfoForm.xocVerified"
                formControlName="xocVerified">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let XOCTransponderVerification of XOCTransponderVerifications"
                  [value]="XOCTransponderVerification">
                  {{XOCTransponderVerification}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('xocVerified').errors?.required">
                Select XOC Verified Transponder Operational
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Clean Dust And Dirt From Enclosure" [(ngModel)]="lastVisitInfoForm.cleanDust"
                formControlName="cleanDust">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let cleanDustOption of CleanDustDirtFromEnclosure" [value]="cleanDustOption">
                  {{cleanDustOption}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('cleanDust').errors?.required">
                Select Clean Dust And Dirt From Enclosure
              </mat-error>
            </mat-form-field> -->
          </p>

          <p>
            <!-- <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Tighten All Enclosure Hardware" [(ngModel)]="lastVisitInfoForm.tightenAll"
                formControlName="tightenAll">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let hardwareTightenOption of TightenAllEnclosureHardwares"
                  [value]="hardwareTightenOption">
                  {{hardwareTightenOption}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('tightenAll').errors?.required">
                Select Tighten All Enclosure Hardware
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Inspect Wire Harnesses And Connectors"
                [(ngModel)]="lastVisitInfoForm.inspectWire" formControlName="inspectWire">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let wireInspection of InspectWireHarnessesConnectors" [value]="wireInspection">
                  {{wireInspection}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('inspectWire').errors?.required">
                Select Inspect Wire Harnesses And Connectors
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Inspect Battery Temperature Probes"
                [(ngModel)]="lastVisitInfoForm.inspectBattery" formControlName="inspectBattery">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let batteryTemperatureInspectionOption of InspectBatteryTemperatureProbes"
                  [value]="batteryTemperatureInspectionOption">
                  {{batteryTemperatureInspectionOption}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('inspectBattery').errors?.required">
                Select Inspect Battery Temperature Probes
              </mat-error>
            </mat-form-field> -->
            <mat-form-field class="mat-form-field-infix-class" appearance="outline">
              <mat-label>Comments(optional)</mat-label>
              <textarea matInput rows="3" formControlName="lastVisitComments"></textarea>
              <mat-error *ngIf="lastVisitInfoForm.get('lastVisitComments').errors?.maxlength">
                Comments can <strong>Maximum</strong> 255 Characters
              </mat-error>
            </mat-form-field>
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput  (change)="trimLeadingAndTrailingSpaces(lastVisitInfoForm.controls['receptacleType'])" placeholder="Receptacle Type" formControlName="receptacleType">
              <mat-error *ngIf="lastVisitInfoForm.get('receptacleType').errors?.required">
                Receptacle Type is required
              </mat-error>
            </mat-form-field>
            <!-- <mat-form-field class="mat-form-field-infix-class">
              <span class="infix" style="width: 50%;">
                <span>Receptacle Type</span><br>
                <mat-radio-group formControlName="receptacleType" [(ngModel)]="lastVisitInfoForm.receptacleType">
                  <mat-radio-button class="mar-right" value="120">120</mat-radio-button>
                  <mat-radio-button class="mar-right" value="240">240</mat-radio-button>
                  <mat-radio-button class="mar-right" value="both">Both</mat-radio-button>
                </mat-radio-group>
              </span>
              <input matInput placeholder="" style="display: none;" formControlName="receptacleType">
              <mat-error *ngIf="lastVisitInfoForm.get('receptacleType').errors?.required">
                Receptacle Type is required
              </mat-error>
            </mat-form-field> -->

            <mat-form-field class="mat-form-field-infix-class">
              <span class="infix" style="width: 50%;">
                <span>Cabinet Vendor</span><br><br>
                <mat-radio-group formControlName="cabinetVendor" [(ngModel)]="lastVisitInfoForm.cabinetVendor">
                  <mat-radio-button class="mar-right" *ngFor="let cabinetVendor of cabinetVendors"
                    [value]="cabinetVendor">{{cabinetVendor}}</mat-radio-button>
                </mat-radio-group>
              </span>
              <input matInput (change)="trimLeadingAndTrailingSpaces(lastVisitInfoForm.controls['cabinetVendor'])"  placeholder="" style="display: none;" formControlName="cabinetVendor">
              <mat-error *ngIf="lastVisitInfoForm.get('cabinetVendor').errors?.required">
                Cabinet Vendor is required
              </mat-error>
            </mat-form-field>

          </p>

          <!-- <p>
            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Power Co Riser Condition" [(ngModel)]="lastVisitInfoForm.powerCo"
                formControlName="powerCo">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let coRiserCondition of coRiserCondition" [value]="coRiserCondition">
                  {{coRiserCondition}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('powerCo').errors?.required">
                Select Power Co Riser Condition
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Battery Heater Mat Type" [(ngModel)]="lastVisitInfoForm.batteryHeaterType"
                formControlName="batteryHeaterType">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let batteryHeaterMatType of batteryHeaterMatTypes" [value]="batteryHeaterMatType">
                  {{batteryHeaterMatType}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('batteryHeaterType').errors?.required">
                Select Battery Heater Mat Type
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput placeholder="Battery Heater Mat Quantity" formControlName="batteryHeaterQuantity">
              <mat-error *ngIf="lastVisitInfoForm.get('batteryHeaterQuantity').errors?.required">
                Select Battery Heater Mat Quantity
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Enclosure Snow Shield" [(ngModel)]="lastVisitInfoForm.encloseSnow"
                formControlName="encloseSnow">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let snowSheildOption of snowSheildOptionss" [value]="snowSheildOption">
                  {{snowSheildOption}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('encloseSnow').errors?.required">
                Select Enclosure Snow Shield
              </mat-error>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput placeholder="Internal Breaker" formControlName="internalBreaker">
              <mat-error *ngIf="lastVisitInfoForm.get('internalBreaker').errors?.required">
                Internal Breaker is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput placeholder="Service Entrance" formControlName="serviceEntrance">
              <mat-error *ngIf="lastVisitInfoForm.get('serviceEntrance').errors?.required">
                Service Entrance is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput placeholder="Receptacle Type" formControlName="receptacleType">
              <mat-error *ngIf="lastVisitInfoForm.get('receptacleType').errors?.required">
                Receptacle Type is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Check Seizure Screw / Alt Box" [(ngModel)]="lastVisitInfoForm.checkSeizure"
                formControlName="checkSeizure">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let seizureScrew of seizureScres" [value]="seizureScrew">
                  {{seizureScrew}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('checkSeizure').errors?.required">
                Select Check Seizure Screw / Alt Box
              </mat-error>
            </mat-form-field>
          </p>

          <p>
            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Is Power Supply ID Legible" [(ngModel)]="lastVisitInfoForm.psIDLegibile"
                formControlName="psIDLegibile">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let powerSupplyIDLegibility of powerSupplyIDLegibilitis"
                  [value]="powerSupplyIDLegibility">
                  {{powerSupplyIDLegibility}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('psIDLegibile').errors?.required">
                Select Is Power Supply ID Legible
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Check Lamps & LEDs" [(ngModel)]="lastVisitInfoForm.checkLamps"
                formControlName="checkLamps">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let lampCheckOption of lampCheckOptionValues" [value]="lampCheckOption">
                  {{lampCheckOption}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('checkLamps').errors?.required">
                Select check Lamps & LEDs
              </mat-error>


            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Check For 20 Amp Hi-Magnetic Circuit Breaker"
                [(ngModel)]="lastVisitInfoForm.checkCircuitBreaker" formControlName="checkCircuitBreaker">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let checkCircuitBreakOption of checkCircuitBreakOptionValues"
                  [value]="checkCircuitBreakOption">
                  {{checkCircuitBreakOption}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('checkCircuitBreaker').errors?.required">
                Select Check For 20 Amp Hi-Magnetic Circuit Breaker
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Visual Inspection Of Cabinet" [(ngModel)]="lastVisitInfoForm.visualInspection"
                formControlName="visualInspection">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let cabinetInspection of cabinetInspectionvalues" [value]="cabinetInspection">
                  {{cabinetInspection}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('visualInspection').errors?.required">
                Select Visual Inspection Of Cabinet
              </mat-error>
            </mat-form-field>
          </p>

          <p>
            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Cabinet Locked" [(ngModel)]="lastVisitInfoForm.cabinetLocked"
                formControlName="cabinetLocked">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let cabinetLockOption of cabinetLockOptionvalues" [value]="cabinetLockOption">
                  {{cabinetLockOption}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('cabinetLocked').errors?.required">
                Select Cabinet Locked
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Security Bar Present" [(ngModel)]="lastVisitInfoForm.securityBar"
                formControlName="securityBar">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let securityBarOption of securityBarOptionvalues" [value]="securityBarOption">
                  {{securityBarOption}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('securityBar').errors?.required">
                Select Security Bar Present
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Check Ground Connection At Cabinet" [(ngModel)]="lastVisitInfoForm.checkGround"
                formControlName="checkGround">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let checkGroundConnection of checkGroundConnectionvalues"
                  [value]="checkGroundConnection">
                  {{checkGroundConnection}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('checkGround').errors?.required">
                Select Check Ground Connection At Cabinet
              </mat-error>
            </mat-form-field>
          </p> -->
          <!-- <div *ngFor="let batteryStringFused of noOfBatteriesFused; let i = index" style="display: inline;">
            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Battery String # {{i+1}} - Fused" [(ngModel)]="batteryStringFused[i]"
                formControlName="batteryStringFused{{i+1}}">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let batteryStringFuse of batteryStringFuses" [value]="batteryStringFuse">
                  {{batteryStringFuse}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('batteryStringFused1').errors?.required && i == 0">
                Select Battery String #1 - Fused
              </mat-error>
              <mat-error *ngIf="lastVisitInfoForm.get('batteryStringFused2').errors?.required && i == 1">
                Select Battery String #2 - Fused
              </mat-error>
              <mat-error *ngIf="lastVisitInfoForm.get('batteryStringFused3').errors?.required && i == 2">
                Select Battery String #3 - Fused
              </mat-error>
              <mat-error *ngIf="lastVisitInfoForm.get('batteryStringFused4').errors?.required && i == 3">
                Select Battery String #4 - Fused
              </mat-error>
              <mat-error  *ngIf="lastVisitInfoForm.get('batteryStringFused5').errors?.required && i == 4">
                Select Battery String #5 - Fused
               </mat-error>
               <mat-error  *ngIf="lastVisitInfoForm.get('batteryStringFused6').errors?.required && i == 5">
                Select Battery String #6 - Fused
              </mat-error>
              <mat-error  *ngIf="lastVisitInfoForm.get('batteryStringFused5').errors?.required && i == 4">
                Select Battery String #5 - Fused
               </mat-error>
               <mat-error  *ngIf="lastVisitInfoForm.get('batteryStringFused6').errors?.required && i == 5">
                Select Battery String #6 - Fused
               </mat-error>
            </mat-form-field>
          </div>
          <mat-form-field class="mat-form-field-infix-class">
            <mat-select placeholder="Tamper Installed And Functioning" [(ngModel)]="lastVisitInfoForm.tamperInstalled"
              formControlName="tamperInstalled">
              <mat-option>--</mat-option>
              <mat-option *ngFor="let tamperInstalledOption of tamperInstalledvalue" [value]="tamperInstalledOption">
                {{tamperInstalledOption}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="lastVisitInfoForm.get('tamperInstalled').errors?.required">
              Select Tamper Installed And Functioning
            </mat-error>
          </mat-form-field> -->

          <p>
            <!-- <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Check LAP's" [(ngModel)]="lastVisitInfoForm.checkLaps"
                formControlName="checkLaps">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let checkLAP of checkLAPsvalue" [value]="checkLAP">
                  {{checkLAP}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('checkLaps').errors?.required">
                Select Check LAP's
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Cabinet Vendor" [(ngModel)]="lastVisitInfoForm.cabinetVendor"
                formControlName="cabinetVendor">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let cabinetVendor of cabinetVendors" [value]="cabinetVendor">
                  {{cabinetVendor}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('cabinetVendor').errors?.required">
                Select Cabinet Vendor
              </mat-error>
            </mat-form-field> -->

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Cabinet Battery Capacity" [(ngModel)]="lastVisitInfoForm.cabinetBattery"
                formControlName="cabinetBattery">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let batteryCapacity of batteryCapacitievalues" [value]="batteryCapacity">
                  {{batteryCapacity}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('cabinetBattery').errors?.required">
                Select Cabinet Battery Capacity
              </mat-error>
            </mat-form-field>

            <!-- <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Check Operating Lights" [(ngModel)]="lastVisitInfoForm.checkOperating"
                formControlName="checkOperating">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let operatingLight of operatingLightvalues" [value]="operatingLight">
                  {{operatingLight}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('checkOperating').errors?.required">
                Select Check Operating Lights
              </mat-error>
            </mat-form-field> -->
            <mat-form-field class="mat-form-field-infix-class">
              <span class="infix" style="width: 50%;">
                <span>Did you clean dust & dirt from enclosure ?</span><br><br>
                <mat-radio-group *ngFor="let cleanDustOption of CleanDustDirtFromEnclosure" formControlName="cleanDust"
                  [(ngModel)]="lastVisitInfoForm.cleanDust">
                  <mat-radio-button class="mar-right" [value]="cleanDustOption">{{cleanDustOption}}</mat-radio-button>
                </mat-radio-group>

              </span>
              <input matInput (change)="trimLeadingAndTrailingSpaces(lastVisitInfoForm.controls['cleanDust'])" placeholder="" style="display: none;" formControlName="cleanDust">
              <mat-error *ngIf="lastVisitInfoForm.get('cleanDust').errors?.required">
                Did you clean dust & dirt from enclosure is required
              </mat-error>
            </mat-form-field>
            <mat-form-field class="mat-form-field-infix-class">
              <span class="infix" style="width: 50%;">
                <span>Is the Cabinet Locked</span><br><br>
                <mat-radio-group formControlName="cabinetLocked" [(ngModel)]="lastVisitInfoForm.cabinetLocked">
                  <mat-radio-button class="mar-right" *ngFor="let cabinetLockOption of cabinetLockOptionvalues"
                    [value]="cabinetLockOption">
                    {{cabinetLockOption}}</mat-radio-button>
                </mat-radio-group>
              </span>
              <input matInput (change)="trimLeadingAndTrailingSpaces(lastVisitInfoForm.controls['cabinetLocked'])" placeholder="" style="display: none;" formControlName="cabinetLocked">
              <mat-error *ngIf="lastVisitInfoForm.get('cabinetLocked').errors?.required">
                Is the Cabinet Locked is required
              </mat-error>
            </mat-form-field>
          </p>

          <!-- <p>
            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Follow Up Action" [(ngModel)]="lastVisitInfoForm.followUp"
                formControlName="followUp">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let followUpActionOption of followUpActionvalue" [value]="followUpActionOption">
                  {{followUpActionOption}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('followUp').errors?.required">
                Select Follow Up Action
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Input Surge Arrestor" [(ngModel)]="lastVisitInfoForm.inputSurge"
                formControlName="inputSurge">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let surgeArrestorInput of surgeArrestorInputs" [value]="surgeArrestorInput">
                  {{surgeArrestorInput}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('inputSurge').errors?.required">
                Select Input Surge Arrestor
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Output Surge Arrestor" [(ngModel)]="lastVisitInfoForm.outputSurge"
                formControlName="outputSurge">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let outputSurgeArrestor of outputSurgeArrestors" [value]="outputSurgeArrestor">
                  {{outputSurgeArrestor}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('outputSurge').errors?.required">
                Select Output Surge Arrestor
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Coax TVSS Present" [(ngModel)]="lastVisitInfoForm.coaxTvss"
                formControlName="coaxTvss">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let coaxOption of coaxOptionvalues" [value]="coaxOption">
                  {{coaxOption}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('coaxTvss').errors?.required">
                Select Coax TVSS Present
              </mat-error>
            </mat-form-field>
          </p> -->
          <p>
            <!-- <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="AC Indicator Green light (ACI)" [(ngModel)]="lastVisitInfoForm.acIndicator"
                formControlName="acIndicator">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let ACIOption of ACIOptionvalues" [value]="ACIOption">
                  {{ACIOption}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('acIndicator').errors?.required">
                Select AC Indicator Green light
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Local and Remote Indicator (LRI)" [(ngModel)]="lastVisitInfoForm.lri"
                formControlName="lri">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let LRIOption of LRIOptionvalues" [value]="LRIOption">
                  {{LRIOption}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('lri').errors?.required">
                Select Local and Remote Indicator (LRI)
              </mat-error>
            </mat-form-field> -->
            <mat-form-field class="mat-form-field-infix-class">
              <span class="infix" style="width: 50%;">
                <span>Did you check ground connection at cabinet?</span><br><br>
                <mat-radio-group formControlName="checkGround" [(ngModel)]="lastVisitInfoForm.checkGround">
                  <mat-radio-button class="mar-right" *ngFor="let checkGroundConnection of checkGroundConnectionvalues"
                    [value]="checkGroundConnection">{{checkGroundConnection}}</mat-radio-button>
                </mat-radio-group>
              </span>
              <input matInput (change)="trimLeadingAndTrailingSpaces(lastVisitInfoForm.controls['checkGround'])"  placeholder="" style="display: none;" formControlName="checkGround">
              <mat-error *ngIf="lastVisitInfoForm.get('checkGround').errors?.required">
                Check ground connection at cabinet is required
              </mat-error>
            </mat-form-field>
            <mat-form-field class="mat-form-field-infix-class">
              <span class="infix" style="width: 50%;">
                <span>Is a tamper installed and functioning?</span><br><br>
                <mat-radio-group formControlName="tamperInstalled" [(ngModel)]="lastVisitInfoForm.tamperInstalled">
                  <mat-radio-button class="mar-right" *ngFor="let tamperInstalledOption of tamperInstalledvalue"
                    [value]="tamperInstalledOption">{{tamperInstalledOption}}</mat-radio-button>
                </mat-radio-group>
              </span>
              <input matInput (change)="trimLeadingAndTrailingSpaces(lastVisitInfoForm.controls['tamperInstalled'])" placeholder="" style="display: none;" formControlName="tamperInstalled">
              <mat-error *ngIf="lastVisitInfoForm.get('tamperInstalled').errors?.required">
                Is a tamper installed and functioning?
              </mat-error>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Input Surge Arrestor" [(ngModel)]="lastVisitInfoForm.inputSurge"
                formControlName="inputSurge">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let surgeArrestorInput of surgeArrestorInputs" [value]="surgeArrestorInput">
                  {{surgeArrestorInput}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('inputSurge').errors?.required">
                Select Input Surge Arrestor
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select placeholder="Output Surge Arrestor" [(ngModel)]="lastVisitInfoForm.outputSurge"
                formControlName="outputSurge">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let outputSurgeArrestor of outputSurgeArrestors" [value]="outputSurgeArrestor">
                  {{outputSurgeArrestor}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="lastVisitInfoForm.get('outputSurge').errors?.required">
                Select Output Surge Arrestor
              </mat-error>
            </mat-form-field>
          </p>
        </div>
        <!-- <mat-form-field style="width:290px;">
          <mat-label>Last Visit Comments</mat-label>
          <textarea matInput rows="3" formControlName="lastVisitComments"></textarea>
          <mat-error *ngIf="lastVisitInfoForm.get('lastVisitComments').errors?.maxlength">
            Comments can <strong>Maximum</strong> 255 Characters
          </mat-error>
          <mat-error *ngIf="lastVisitInfoForm.get('lastVisitComments').errors?.required"> -->
            <!-- Last Visit Comments -->
          <!-- </mat-error>
        </mat-form-field> -->
        <div class="infixcheck">
          <label class="mat-form-field-infix-class"><b style="margin-left:35px;color: #7e7e7e;
          font-size: 15px;">Did you check the following?</b></label>
          <div style="margin-left:35px;" class="didVerify">
          <label class="labelfollow">Seizure screw/alt box</label><br>
          <label class="labelfollow">Power co riser condition</label><br>
          <label class="labelfollow">20 amp hi-magnetic circuit breaker</label><br>
          <label class="labelfollow">LAP's</label><br>
          <label class="labelfollow">Cabinet Condition</label><br>
          <label class="labelfollow">Inspect wire harnesses/connectors</label><br>
          <label class="labelfollow">Lamps/LEDS</label><br>
          <label class="labelfollow">Battery temperature probes</label><br>
          <label class="labelfollow">XOC Verified transponder is operational</label><br>
          <label class="labelfollow">Operating/AC indicator lights</label><br>
          <label class="labelfollow">Service entrance</label><br>
          <label class="labelfollow">Power Supply Id is legible</label><br>
          <label class="labelfollow">Local remote Indicator</label><br>
            <p><label class="example-margin labelfollow verifychk">Verified All</label>&nbsp;&nbsp;
              <mat-checkbox [checked]="isCheckedCheck" #chkEnable (change)="SelectAllOk(chkEnable.checked)"></mat-checkbox>
            </p>
          </div>
        </div>
      </form>
      <br>
    </mat-tab>

    <!--Image Section-->
    <mat-tab label="Edit Photo(s)">
      <button style="margin-top: 10px;margin-bottom: 10px;" type="button" matTooltip="Offline Picture Upload" class="btn btn-primary textsize"
      (click)="openAddEntryDialog('Test')">Offline Picture Upload</button>
      <form id="photoInfoForm">
        <mat-card *ngFor="let imagedata of detailedImage">
          <mat-card-title class="titleHeader">
            <div>{{imagedata.id+". "+imagedata.name}}</div>
          </mat-card-title>
          <mat-card-content class="imagePos">
            <br>
            <img *ngIf="imagedata.url" [src]="imagedata.url" class="imageSrc"><br>
            <img *ngIf="!imagedata.url" src="./assets/noprev.jpg" class="noPrev"><br>
            <input type="file" accept="image/x-png,image/jpeg,image/jpg" id="{{imagedata.id}}" style="display:none;"
              (change)="onselectFile($event,imagedata.id,imagedata)" #file_uploadOne>
            <img (click)="file_uploadOne.click()" src="../../../assets/upload.png" class="uploadIcon"><br>
            <mat-label class="imageNav" (click)="file_uploadOne.click()"><b *ngIf="imagedata.url">Replace Photo</b><b
                *ngIf="!imagedata.url">Upload Photo</b></mat-label>
          </mat-card-content>
        </mat-card>
        <hr class="bottomLine">
      </form>
    </mat-tab>
  </mat-tab-group>
</div>
